import {Form} from '@shopify/hydrogen/experimental';
import {useState} from 'react';
import {AnimatePresence, motion} from 'framer-motion';

import {Image} from '@shopify/hydrogen';
import {useSiteContext} from '../../hooks/useSiteContext';

export const Subscribe = ({text}: any) => {
  const [submitted, setSubmitted] = useState<boolean>(false);

  const {state} = useSiteContext();

  const host = import.meta.env.PUBLIC_FUNCTION_HOST;

  function handleSubmit(e: any) {
    e.preventDefault();
    fetch(`${host}/subscribe`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify({
        email: e.target.email?.value,
        country: state?.geoFenceCode,
      }),
    }).then(() => {
      setSubmitted(true);
    });
  }

  return (
    <div className="flex w-full max-w-[640px] flex-col gap-y-8">
      <Image
        width="210px"
        height="30px"
        data={{
          url: 'https://cdn.sanity.io/images/15oppjc2/production/aa1b3cf1c79560d984a0ef0de88b4307027c0407-446x62.png',
        }}
        className="w-full max-w-[210px]"
        alt="Goodnature trap"
      />
      <p className="richH3 text-orange">{text}</p>

      <AnimatePresence mode="wait">
        {submitted ? (
          <motion.div
            key={submitted}
            initial={{opacity: 0}}
            animate={{opacity: 1}}
            exit={{opacity: 0}}
            className="blockH7"
          >
            <h6 className="richH6 text-orange">
              Thank you for subscribing to Goodnature.
            </h6>
          </motion.div>
        ) : (
          <motion.div
            key={submitted}
            initial={{opacity: 0}}
            animate={{opacity: 1}}
            exit={{opacity: 0}}
          >
            <p className="blockH10 mb-4 text-white">
              By continuing, you are agreeing to Goodnature's{' '}
              <a
                href="/terms/privacy-policy"
                className="text-orange underline underline-offset-2"
              >
                Privacy Policy
              </a>
            </p>
            <Form
              onSubmit={(e) => handleSubmit(e)}
              className="flex items-center justify-between gap-x-4 rounded-full bg-white pl-4 lg:w-[85%]"
            >
              <input
                type="text"
                name="email"
                id="email"
                placeholder="Sign up to our newsletter"
                className="w-full border-0 bg-none !p-0 text-dark-grey outline-none focus:ring-0"
              />
              <input
                type="text"
                name="country"
                id="country"
                hidden
                onChange={() => null}
                value={state?.geoFenceCode}
              />
              <button
                type="submit"
                onClick={() => setSubmitted(true)}
                className="btn-standard !md:px-12 !w-max translate-x-[1px] whitespace-nowrap !px-7 !py-3"
              >
                Sign Up
              </button>
            </Form>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
